import React from 'react';
import { Modal } from "reactstrap";

export default function  ModalTimeOut(props) {

    /**
     * Get properties
     */
    const { modal, toggle, message, callback } = props;

    return (
        <Modal
            isOpen = { modal }
            className="modal modal-timeout"
        >
            <div className="text-center message">{message}</div>
            <div className="group-button text-center">
                <button className="btn btn-sm" onClick={ callback ? callback : toggle }>OK</button>
            </div>
        </Modal>
    );
}
